(function () {
  function productSection(composer) {
    return composer.closest('[data-section-type="product-section"]') || composer.parentElement;
  }

  function buttonForm(composer) {
    return document.getElementById('product-form-buttons-' + composer.dataset.sectionId) || composer.closest('form');
  }

  function nativeSelector(composer) {
    var form = composer.closest('form');
    if (!form) return null;

    return form.querySelector(
      '.product__variants-swatches[data-section-id="' + composer.dataset.sectionId + '"], .product__variants-select[data-section-id="' + composer.dataset.sectionId + '"]'
    );
  }

  function selectNativeOption(composer, position, value) {
    var wrapper = nativeSelector(composer);
    if (!wrapper) return;

    var radio = Array.prototype.find.call(
      wrapper.querySelectorAll('input[type="radio"][data-position="' + position + '"]'),
      function (input) { return input.value === value; }
    );

    if (radio) {
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var select = Array.prototype.find.call(
      wrapper.querySelectorAll('select.js-variant-selector'),
      function (item) { return item.querySelector('option[data-position="' + position + '"]'); }
    );

    if (select && select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function renderComposer(composer) {
    var pressed = composer.querySelector('[data-mm-offer-button][aria-pressed="true"]');
    var count = pressed ? Number(pressed.dataset.mmCount) : 1;
    var values = [];

    composer.querySelectorAll('[data-mm-slot-row]').forEach(function (row) {
      var active = Number(row.dataset.mmSlotRow) <= count;
      var select = row.querySelector('[data-mm-cushion-slot]');
      row.hidden = !active;
      select.disabled = !active;
      if (active) values.push(select.value);
    });

    var summary = composer.querySelector('[data-mm-cushion-summary]');
    if (summary) summary.textContent = 'Votre composition : ' + values.join(' · ');

    var total = composer.querySelector('[data-mm-cushion-total]');
    if (total && pressed) total.textContent = 'Total de l’offre : ' + pressed.dataset.mmOfferTotal;
  }

  function initializeComposer(composer) {
    var section = productSection(composer);
    var form = buttonForm(composer);
    var firstSlot = composer.querySelector('[data-mm-cushion-slot="1"]');

    if (section) {
      section.classList.add('mm-cushion-product');
      section.querySelectorAll('[data-product-qty]').forEach(function (quantity) {
        quantity.hidden = true;
      });
    }

    if (form) {
      form.classList.add('mm-cushion-product-form');
      var quantityInput = form.querySelector('[name="quantity"]');
      if (quantityInput) quantityInput.value = '1';
    }

    if (firstSlot) {
      selectNativeOption(composer, composer.dataset.offerPosition, composer.dataset.singleOfferValue);
      selectNativeOption(composer, composer.dataset.motifPosition, firstSlot.value);
    }

    renderComposer(composer);
  }

  function initializeComposers() {
    document.querySelectorAll('[data-mm-cushion-composer]').forEach(initializeComposer);
  }

  function composerForForm(form) {
    if (!form) return null;

    var direct = form.querySelector('[data-mm-cushion-composer]');
    if (direct) return direct;

    var prefix = 'product-form-buttons-';
    var formId = form.getAttribute('id') || '';
    if (formId.indexOf(prefix) === 0) {
      if (!form.classList.contains('product_form')) return null;
      return document.querySelector(
        '[data-mm-cushion-composer][data-section-id="' + formId.slice(prefix.length) + '"]'
      );
    }

    var section = form.closest('[data-section-type="product-section"]');
    return section ? section.querySelector('[data-mm-cushion-composer]') : null;
  }

  function selectedComposition(composer) {
    var pressed = composer.querySelector('[data-mm-offer-button][aria-pressed="true"]');
    var count = pressed ? Number(pressed.dataset.mmCount) : 1;
    var selections = [];

    composer.querySelectorAll('[data-mm-cushion-slot]').forEach(function (select) {
      if (Number(select.dataset.mmCushionSlot) > count) return;

      var option = select.selectedOptions[0];
      var id = option ? Number(option.dataset.mmVariantId) : 0;
      if (!id) throw new Error('Référence fournisseur introuvable pour ' + select.value);

      selections.push({
        id: id,
        motif: select.value,
        sku: option.dataset.mmSku || ''
      });
    });

    if (selections.length !== count) {
      throw new Error('La composition du lot est incomplète.');
    }

    return {
      count: count,
      label: pressed ? pressed.dataset.mmOfferValue : '1 coussin',
      selections: selections
    };
  }

  function cartItems(composition) {
    var grouped = {};
    var bundleId = 'MM-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
    var summary = composition.selections.map(function (item) { return item.motif; }).join(' + ');

    composition.selections.forEach(function (selection) {
      if (!grouped[selection.id]) {
        grouped[selection.id] = {
          id: selection.id,
          quantity: 0,
          properties: {
            '_Offre Maison Milaya': composition.label,
            '_Composition Maison Milaya': summary,
            '_Référence du lot': bundleId
          }
        };
      }
      grouped[selection.id].quantity += 1;
    });

    return Object.keys(grouped).map(function (id) { return grouped[id]; });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { cartItems: cartItems };
  }

  if (typeof document === 'undefined') return;

  function showError(form, message) {
    var error = form && form.querySelector('.js-error-msg');
    if (!error) {
      window.alert(message);
      return;
    }

    error.textContent = message;
    error.style.display = 'block';
  }

  function addComposition(composer, form, button) {
    if (composer.dataset.mmSubmitting === 'true') return;

    var composition;
    try {
      composition = selectedComposition(composer);
    } catch (error) {
      showError(form, error.message);
      return;
    }

    composer.dataset.mmSubmitting = 'true';
    if (button) {
      button.disabled = true;
      button.classList.add('disabled');
      button.dataset.mmOriginalText = button.textContent;
      button.textContent = 'Ajout en cours…';
    }

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: cartItems(composition) })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || data.message || 'Impossible d’ajouter cette composition.');
          });
        }
        return response.json();
      })
      .then(function () {
        window.location.href = composer.dataset.cartUrl || '/cart';
      })
      .catch(function (error) {
        composer.dataset.mmSubmitting = 'false';
        if (button) {
          button.disabled = false;
          button.classList.remove('disabled');
          button.textContent = button.dataset.mmOriginalText || 'Ajouter au panier';
        }
        showError(form, error.message);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mm-offer-button]');
    if (!button) return;

    var composer = button.closest('[data-mm-cushion-composer]');
    composer.querySelectorAll('[data-mm-offer-button]').forEach(function (item) {
      item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
    });

    /*
     * Keep Shopify's native variant on the real single-cushion SKU.
     * The bundle size is handled by the multi-item cart payload below.
     * Selecting a legacy P2/P3 option here would make the theme disable the
     * add-to-cart button because those safety variants are intentionally sold out.
     */
    selectNativeOption(composer, composer.dataset.offerPosition, composer.dataset.singleOfferValue);
    renderComposer(composer);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-mm-mobile-option-select]')) {
      var option = event.target.selectedOptions[0];
      var input = option && document.getElementById(option.dataset.targetId);
      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    if (event.target.matches('[data-mm-cushion-slot]')) {
      var composer = event.target.closest('[data-mm-cushion-composer]');
      if (event.target.dataset.mmCushionSlot === '1') {
        selectNativeOption(composer, composer.dataset.motifPosition, event.target.value);
      }
      renderComposer(composer);
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.js-ajax-submit');
    if (!button) return;

    var form = button.closest('form');
    var composer = composerForForm(form);
    if (!composer) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addComposition(composer, form, button);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var composer = composerForForm(form);
    if (!composer) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addComposition(composer, form, form.querySelector('.js-ajax-submit'));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeComposers);
  } else {
    initializeComposers();
  }
})();
